// extracted by mini-css-extract-plugin
export default {"modalTitle":"DeleteModal_modalTitle__nEtFa","modalButtonsContainer":"DeleteModal_modalButtonsContainer__QjeF6"};